(function ($) {
  'use strict'

  Drupal.behaviors.promoWrapper = {
    attach: function (context) {

      const promos = $('.paragraph--generic-promo.view-mode--square-image-promo, .paragraph--generic-promo.view-mode--low-promo', context)

      promos.each(function () {
        const url = $(this).find('.paragraph--button-component a').attr('href')
        if (url) {
          let target = ''
          if (url.indexOf('::')) {
            target = '_blank'
          }

          $(this).wrap('<a class="paragraph paragraph--generic-promo swiper-slide" target="' + target + '" href="' + url + '" />')
        }
      });
    }
  }
})(jQuery)
